import { Injectable } from '@angular/core';
import { ignoreDomainSwitchHttpStatus, SwitchDomainService } from 'ngx-auth-util-lib';
import { environment } from '../../environments/local/environment';
import { LoadingService } from './loading/loading.service';

/**
 * Similar to other app's but intentionally not in library because of routing reason.
 */
@Injectable({
  providedIn: 'root'
})
export class DomainHandlerService {
  constructor(private switchDomainService: SwitchDomainService, private loadingService: LoadingService) {}

  public switchDomainAndReload(domainId: string) {
    this.loadingService.setLoading(true);
    this.switchDomainService.switchDomain(domainId).subscribe({
      next: () => this.reloadApplication(),
      error: err => {
        if (err?.status != ignoreDomainSwitchHttpStatus) {
          this.loadingService.setLoading(false);
          throw err;
        }
        this.reloadApplication();
      }
    });
  }

  public reloadApplication(targetPath?: string) {
    if (targetPath) {
      window.location.href = `${environment.redirect.host}/${targetPath}`;
    } else {
      window.location.href = environment.redirect.host;
    }
  }
}
